import { render, staticRenderFns } from "./CTACont.vue?vue&type=template&id=15945199&scoped=true"
import script from "./CTACont.vue?vue&type=script&lang=js"
export * from "./CTACont.vue?vue&type=script&lang=js"
import style0 from "./CTACont.vue?vue&type=style&index=0&id=15945199&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15945199",
  null
  
)

export default component.exports